import { Controller } from "@hotwired/stimulus"
import Logger from '../lib/logger'

export default class extends Controller {
  static values = { mrc: Number }

  connect() {
    Logger.debug('ApplyProposalController connected')
  }

  disconnect() {
    Logger.debug('ApplyProposalController disconnected')
  }

  apply() {
    const mrcInput = document.querySelector('input[name="quote[mrc]"]')
    if (mrcInput) {
      mrcInput.value = this.mrcValue.toFixed(2)
      // trigger input event for validation and other listeners
      mrcInput.dispatchEvent(new Event('input', { bubbles: true }))
      
      Logger.success('Applied smart proposed price', { price: this.mrcValue })
    } else {
      Logger.error('MRC input not found when applying proposal')
    }
  }

  dismiss() {
    const container = document.getElementById('quote_proposal_container')
    if (container) {
      container.innerHTML = ''
      Logger.debug('Dismissed smart proposals')
    }
  }
}
